import { Anchor, Breadcrumbs, Grid, Text } from '@mantine/core';
import queryString from 'query-string';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router';
import { v4 as uuidv4 } from 'uuid';
import ErrorMessage from '../../components/ErrorMessage';
import Metadata from '../../components/Metadata';
import ProductFeedForm from '../../components/ProductFeeds/ProductFeedForm';
import Spinner from '../../components/Spinner';
import { Page } from '../../constants/pageTitles';
import recommenderRules from '../../constants/recommenderRules';
import useFetch from '../../helpers/useFetch';

const page = `${Page['productFeed']}`;

const ProductFeedsNewPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const fetch = useFetch();

  const [productFeed, setProductFeed] = useState();
  const [userError, setUserError] = useState();
  const [loadError, setLoadError] = useState();
  const [loading, setLoading] = useState(false);

  const { accountId, domainId } = useParams();
  const { domain } = useSelector((state) => state.domain);

  const editor = queryString.parse(location.search).editor;

  useEffect(() => {
    const from = queryString.parse(location.search).from;
    if (!from) {
      setProductFeed({
        name: 'New product feed',
        algorithm: '',
        scope: 'marketingChannels',
        rules: recommenderRules,
        tags: [],
        fallback: 'popularScoreByCartAdd',
        options: {},
      });
      return;
    }

    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/productFeeds/${from}`)
      .then(({ productFeed }) => {
        productFeed.name = `Copy of ${productFeed.name}`;
        delete productFeed.id;
        productFeed.externalId = uuidv4();
        setProductFeed(productFeed);
      })
      .catch(setLoadError);
  }, [accountId, domainId, domain.senderName, fetch, editor, location.search]);

  const create = (productFeed) => {
    setLoading(true);
    fetch(`/api/admin/accounts/${accountId}/domains/${domainId}/productFeeds`, {
      method: 'POST',
      body: JSON.stringify(productFeed),
    })
      .then(() => {
        navigate(location.pathname.replace(`/productFeeds/new`, '/productFeeds'));
      })
      .catch(setUserError)
      .finally(() => setLoading(false));
  };

  if (loadError) {
    return <ErrorMessage message={loadError.message} />;
  }

  if (!productFeed) {
    return <Spinner />;
  }

  const breadcrumbItems = [
    { title: 'Home', href: `#/accounts/${accountId}/domains/${domainId}/analytics` },
    { title: page, href: `#/accounts/${accountId}/domains/${domainId}/productFeeds` },
    { title: 'New' },
  ].map((item, index) =>
    item.href ? (
      <Anchor href={item.href} key={index}>
        {item.title}
      </Anchor>
    ) : (
      <Text key={index}>{item.title}</Text>
    )
  );

  return (
    <>
      <Metadata title={`${page} | New`} />
      <Breadcrumbs mb="md">{breadcrumbItems}</Breadcrumbs>

      <Grid>
        <Grid.Col span={12}>
          <ProductFeedForm
            loading={loading}
            productFeed={productFeed}
            cancel={() => navigate(`/accounts/${accountId}/domains/${domainId}/productFeeds`)}
            saveProductFeed={(productFeed) => create(productFeed)}
          />
        </Grid.Col>
      </Grid>
      {userError ? (
        <div style={{ textAlign: 'right' }}>
          <ErrorMessage message={userError.message} />
        </div>
      ) : null}
    </>
  );
};

export default ProductFeedsNewPage;
